import { useEffect } from "react"
import TagManager from "react-gtm-module"

import { Manrope } from "@next/font/google"
import { Analytics } from "@vercel/analytics/react"
import { ThemeProvider } from "next-themes"
import type { AppProps } from "next/app"
import Head from "next/head"
import Smartlook from "smartlook-client"

import Layout from "../components/layout"
import "../styles/globals.css"

const manrope = Manrope({
  subsets: ["latin-ext"],
  display: "swap",
  variable: "--font-sans",
})

const tagManagerArgs = {
  gtmId: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
}

function MyApp({ Component, pageProps }: AppProps) {
  useEffect(() => {
    Smartlook.init(process.env.NEXT_PUBLIC_SMARTLOOK_PROJECT_KEY)
    if (process.env.NODE_ENV === "production") {
      TagManager.initialize(tagManagerArgs)
    }
  }, [])
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <div className={`${manrope.variable} font-sans`}>
        <Head>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Head>
        <Layout>
          <Component {...pageProps} />
          <Analytics />
        </Layout>
      </div>
    </ThemeProvider>
  )
}

export default MyApp
